import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import { Alert, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import useWidgetStore from "../../store/useWidgetStore";
import { CustomSelectElement } from '../../layouts/Theme';
import { useFormContext } from 'react-hook-form';
import { useI18N } from '../../context/I18NContext';
import AmountSelect from '../actions/AmountSelect';
export default function CapacityPicker(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { selectedCapacity, selectedCapacityGroups, selectedResource, setSelectedCapacity, setSelectedCapacityGroups } = useWidgetStore();
    // @ts-ignore
    // props.config.required = true
    useEffect(() => {
        var _a, _b;
        if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.required) {
            // only if we have multiple options, set it to an unselected state
            let options = (props.config.max ? props.config.max + 1 : 100) - (props.config.min ? props.config.min : 1);
            if (options > 1) {
                setSelectedCapacity(0);
            }
            else {
                setSelectedCapacity((_b = props.config.min) !== null && _b !== void 0 ? _b : 1);
            }
        }
    }, [(_a = props.config) === null || _a === void 0 ? void 0 : _a.required]);
    const theme = useTheme();
    const { t, ts } = useI18N();
    const { setValue } = useFormContext();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const [values, setValues] = useState({});
    const [showMinError, setShowMinError] = useState(false);
    const [showMaxError, setShowMaxError] = useState(false);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.rules) === null || _b === void 0 ? void 0 : _b.length) === 0 && !props.config.required) {
            setSelectedCapacity((_d = (_c = props.config) === null || _c === void 0 ? void 0 : _c.min) !== null && _d !== void 0 ? _d : 1);
            setSelectedCapacityGroups({ 0: (_f = (_e = props.config) === null || _e === void 0 ? void 0 : _e.min) !== null && _f !== void 0 ? _f : 1 });
        }
    }, [(_b = props.config) === null || _b === void 0 ? void 0 : _b.rules]);
    useEffect(() => {
        var _a, _b;
        if (((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.rules) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            // we only have multiple person, but no specific groups
            // set the "group" too, as it is used by prepare and uppdate cart to determine price and capacity
            // in some cases, and not just the selectedCapacity ( I have no clue what's used when, but we need to post 
            // both capacity: number AND capacities: { 0 : number } in order to not throw exceptions from the cart form
            setSelectedCapacityGroups({ 0: selectedCapacity });
        }
    }, [selectedCapacity]);
    if (((_d = (_c = props.config) === null || _c === void 0 ? void 0 : _c.rules) === null || _d === void 0 ? void 0 : _d.length) === 0) {
        return (_jsx(_Fragment, { children: _jsx(AmountSelect, { required: (_f = (_e = props.config) === null || _e === void 0 ? void 0 : _e.required) !== null && _f !== void 0 ? _f : false, value: selectedCapacity, setter: setSelectedCapacity, min: (_g = props.config) === null || _g === void 0 ? void 0 : _g.min, max: (_h = props.config) === null || _h === void 0 ? void 0 : _h.max, label: t((_k = (_j = props.config) === null || _j === void 0 ? void 0 : _j.label) !== null && _k !== void 0 ? _k : 'Aantal') }) }));
    }
    // the rest is only relevant if we have groups defined
    // also, the required config option isn't relevant when groups are defined, as those
    // selects include 0s ( unless they have a min value ) and therefore the manual
    // selection requirement is implicit
    const updateValues = () => {
        var _a, _b;
        if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.rules) {
            let total = 0, groups = {};
            (_b = props.config.rules) === null || _b === void 0 ? void 0 : _b.forEach((rule) => {
                var _a, _b, _c;
                setValue(`amount-${rule.groupId}`, (_a = rule.minCapacity) !== null && _a !== void 0 ? _a : 0);
                total += (_b = rule.minCapacity) !== null && _b !== void 0 ? _b : 0;
                groups[rule.groupId] = (_c = rule.minCapacity) !== null && _c !== void 0 ? _c : 0;
            });
            setValue('amount', total);
            setSelectedCapacity(total);
            if (selectedCapacityGroups) {
                let _total = 0;
                for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                    if (_key !== '0') {
                        setValue(`amount-${_key}`, _value);
                        _total += _value;
                        groups[parseInt(_key)] = _value;
                    }
                }
                if (_total > 0) {
                    setValue('amount', _total);
                }
                setSelectedCapacity(_total);
            }
            setValues(groups);
            setSelectedCapacityGroups(groups);
        }
    };
    useEffect(() => {
        updateValues();
    }, []);
    useEffect(() => {
        updateValues();
    }, [selectedResource]);
    const onChange = (value) => {
        var _a, _b, _c, _d;
        let _value = value.target, groupId = parseInt(_value.name.substring(7)), _values = values;
        _values[groupId] = _value.value;
        let _total = 0;
        for (const [_key, _value] of Object.entries(_values)) {
            _total += _value;
        }
        let minError = _total < ((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : 1), maxError = _total > ((_d = (_c = props.config) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : 100);
        setShowMinError(minError);
        setShowMaxError(maxError);
        if (!minError && !maxError) {
            setValues(_values);
            setSelectedCapacityGroups(_values);
            setValue('amount', _total);
            setSelectedCapacity(_total);
        }
        else {
            // this disables the date and time queries
            setSelectedCapacity(0);
        }
    };
    return (_jsxs(_Fragment, { children: [(_m = (_l = props.config) === null || _l === void 0 ? void 0 : _l.rules) === null || _m === void 0 ? void 0 : _m.map((rule, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                let group = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.find((group) => group.id === rule.groupId);
                let options = [];
                for (let i = ((_c = rule.minCapacity) !== null && _c !== void 0 ? _c : 1); i < (rule.maxCapacity ? rule.maxCapacity + 1 : 100); i++) {
                    options.push({ id: i, label: i.toString() });
                }
                return (_jsx(Fragment, { children: options.length > 1 && (_jsx(Box, { sx: { minWidth: 120, my: 1, maxWidth: isLarge ? '500px' : '100%' }, children: _jsx(CustomSelectElement, { id: `amount-${group === null || group === void 0 ? void 0 : group.id}`, label: t((_d = group === null || group === void 0 ? void 0 : group.name) !== null && _d !== void 0 ? _d : "Aantal", "select"), defaultValue: (_e = rule.minCapacity) !== null && _e !== void 0 ? _e : 0, value: ((_f = props.config) === null || _f === void 0 ? void 0 : _f.required) ? undefined : ((_h = values[(_g = group === null || group === void 0 ? void 0 : group.id) !== null && _g !== void 0 ? _g : 0]) !== null && _h !== void 0 ? _h : 1), name: `amount-${group === null || group === void 0 ? void 0 : group.id}`, placeholder: t('Selecteer aantal personen', "select"), inputProps: {
                                //@ts-ignore
                                onChange: onChange
                            }, options: options }) })) }, i));
            }), showMinError && (_jsx(Alert, { sx: { my: 2, mx: 1 }, severity: "warning", children: _jsx(Typography, { children: ts('Selecteer ten minste %amount% %amount=1?persoon:personen%', { amount: (_p = (_o = props.config) === null || _o === void 0 ? void 0 : _o.min) !== null && _p !== void 0 ? _p : 1 }, "select") }) })), showMaxError && (_jsx(Alert, { sx: { my: 2, mx: 1 }, severity: "warning", children: _jsx(Typography, { children: ts('Selecteer maximaal %amount% %amount=1?persoon:personen%', { amount: (_r = (_q = props.config) === null || _q === void 0 ? void 0 : _q.max) !== null && _r !== void 0 ? _r : 1 }, "select") }) }))] }));
}
